import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { GoHomeContainer, WorkTimeCalendarContainer, Changelog, ToDo } from '@/router/pages'

export default () => (
  <div>
    <Switch>
      <Route exact path="/" component={GoHomeContainer}/>
      <Route exact path="/calendar" component={WorkTimeCalendarContainer}/>
      <Route exact path="/changelog" component={Changelog}/>
      <Route exact path="/todo" component={ToDo}/>
      <Route exact path="/errorpage" component={ErrorPage}/>
      <Route exact path="/forbidden" component={Forbidden}/>
      <Route component={NoMatch} />
    </Switch>
  </div>
)

export const ErrorPage = () => (
  <div>
    <h1 className="text-danger">앗! 무언가 잘못됐다!</h1>
  </div>
)

export const NoMatch = ({ location }) => (
  <div>
    <h3>No match for <code>{location.pathname}</code></h3>
  </div>
)

export const Forbidden = ({ location }) => (
  <div>
    <h3>사용 권한 받으세요.</h3>
  </div>
)



// WEBPACK FOOTER //
// ./src/router/index.js